import axios from 'axios';
import { reset, setToken } from '../redux/userSlice';
import { userApi } from './user';

const apiClient = axios.create({
  	baseURL: 'https://api.ywcnp.com/',
  	timeout: 10000,
  	headers: {
		'Content-Type': 'application/json',
  	},
});

// store를 필요할 때 동적으로 가져오는 함수
const getStore = () => {
  return require('../redux/store').default;
};

// 요청 인터셉터 (모든 요청 전에 실행) - 토큰 관련 사항
apiClient.interceptors.request.use(config => {
		if(!config.skipAuth) {
			const store = getStore();
			const token = store.getState().user.token;

			if(token) {
				config.headers['Authorization'] = `Bearer ${token}`;
			}
		}
		
		return config;	
	}, error => {
  		return Promise.reject(error);
	}
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
	failedQueue.forEach(prom => {
		if (error) prom.reject(error);
		else prom.resolve(token);
	});
	failedQueue = [];
};

// 응답 인터셉터
apiClient.interceptors.response.use(response => {
		return response.data; // 응답 데이터만 반환
	}, 
	async (error) => {
		const originalRequest = error.config;
		console.log('API Error Interceptor Triggered', error);

  		// Handle errors globally
		if(error.response?.status === 403 &&
			error.response?.data?.errorCode === 403601 &&
			!originalRequest._retry
		) {
			// access token expired
			console.log('Access token expired. Attempting to refresh token...');

			if(isRefreshing) {
				return new Promise(function(resolve, reject) {
					failedQueue.push({resolve, reject});
				}).then(token => {
					originalRequest.headers['Authorization'] = `Bearer ${token}`;
					return apiClient(originalRequest);
				});
			}

			originalRequest._retry = true;
			isRefreshing = true;
			const store = getStore();

			try{
				const result = await userApi.reissueAccessToken();
				console.log('New access token received:', result.accessToken);
				const newAccessToken = result.accessToken;

				// 새로운 토큰으로 헤더 업데이트
				store.dispatch(setToken(newAccessToken));
				originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

				processQueue(null, newAccessToken);
				isRefreshing = false;

				// 원래 요청 재시도
				return apiClient(originalRequest);
			} catch (tokenRefreshError) {
				// 리프레시 실패 시 로그아웃
				console.error('Token refresh failed:', tokenRefreshError);
				processQueue(tokenRefreshError, null);
				isRefreshing = false;

				store.dispatch(reset());
				window.location.href = '/log-in';
				return Promise.reject(tokenRefreshError);
			}
		}

  		// Handle errors globally
		if(error.response && (
			error.response.data.errorCode === 401603 ||
			error.response.data.errorCode === 401605 ||
			error.response.data.errorCode === 403602 ||
			error.response.data.errorCode === 404602
		)) {
			// 그 외 인증 오류 시 로그아웃
			const store = getStore();
			store.dispatch(reset());
			window.location.href = '/log-in';
			return Promise.reject(error);
		}

		console.error('API Error:', error.response ? error.response.data : error.message);
		return Promise.reject(error);
	}
);

export default apiClient;